import { render } from "./PaywallSessionLimit.vue?vue&type=template&id=24dd641a"
import script from "./PaywallSessionLimit.vue?vue&type=script&setup=true&lang=js"
export * from "./PaywallSessionLimit.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Paywall/PaywallSessionLimit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "24dd641a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('24dd641a', __exports__)) {
    api.reload('24dd641a', __exports__)
  }
  
  module.hot.accept("./PaywallSessionLimit.vue?vue&type=template&id=24dd641a", () => {
    api.rerender('24dd641a', render)
  })

}


export default __exports__